import {css} from 'styled-components';

export const touchScroll = css`
  -webkit-overflow-scrolling: touch;
  touch-action: manipulation;
`;

export const hideScrollBar = css`
  box-sizing: border-box;
  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;
